import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { DetalheVeiculo } from "../typings";

export function useDetalhesVeiculo(id?: string) {
  return useQuery<DetalheVeiculo, AxiosError>(
    `/v1/veiculo/${id}`,
    async () => {
      const {data} = await http.get<DetalheVeiculo>(`/v1/veiculo/${id}`);

      return data;
    },
    { enabled: !!id }
  );
}
